import makeCrud from '@/store/site/localization/crud'

// Depolar arası transferler — CRUD; transition aksiyonu sayfa içinde axios ile.
export default makeCrud('ecommerce_stock_transfer')
